<template>
<div class="chapter">
<div class="inner_page">
<div class="part" id="pt01">
<div class="partHead" id="ph01">
<h2 class="partNumber" style="text-indent: 0%;"><span class="bold">Part I</span></h2>
<h2 class="partTitle" style="text-indent: 0%;"><span class="bold">The Shining Light and the Huddled Masses</span></h2>
<p class="centerImage"><img alt="image" class="epubimage" height="373" id="img2" src="23.jpg" width="296"/></p>
<p class="caption" style="text-indent:0%;"><span class="bold">Lillian Gish in <em class="italic">The Birth of a Nation</em></span></p>
</div>
<div class="partBody">
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781466827714_pt01.vue?88bb24fa